import applicationFormService from '../../services/applicationForm.service';
import { GetProtectionPlusEnrollmentUrlInput, GetProtectionPlusEnrollmentUrlResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import { NetworkError } from '../../state-machine/actions/genericActions';

const getProtectionPlusEnrollmentUrl = async (appId: number): Promise<GetProtectionPlusEnrollmentUrlResponse | undefined> => {
  try {
    const input: GetProtectionPlusEnrollmentUrlInput = {
      applicationId: appId,
    };

    const { data } = await applicationFormService.getProtectionPlusEnrollmentUrl(input);
    return data?.getProtectionPlusEnrollmentUrl as GetProtectionPlusEnrollmentUrlResponse;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default getProtectionPlusEnrollmentUrl;
